import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { imagePropTypes } from '../../../propTypes';

import VideoPlayer from '../VideoPlayer';

const propTypes = {
  fallbackImage: imagePropTypes,
  reverse: PropTypes.bool,
  text: PropTypes.string,
  title: PropTypes.string,
  videoUrl: PropTypes.string.isRequired,
};

const defaultProps = {
  fallbackImage: undefined,
  reverse: false,
  text: '',
  title: '',
};

function SplitVideo(props) {
  return (
    <div className="Component MediaSplit">
      <div className="MediaSplit_container">
        <div className="MediaSplit_body">
          <div
            className={classNames('MediaSplit_content', {
              'MediaSplit_content-reverse': props.reverse,
            })}
          >
            <div className="MediaSplit_text">
              <h3 className="MediaSplit_title">{props.title}</h3>
              <div className="MediaSplit_wysiwyg">{props.text}</div>
            </div>
            <div className="MediaSplit_media">
              <VideoPlayer videoUrl={props.videoUrl} fallbackImage={props.fallbackImage} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

SplitVideo.propTypes = propTypes;
SplitVideo.defaultProps = defaultProps;

export default SplitVideo;
